import ReducerIndex from 'qwc2/reducers/index';
import {zoomToPoint} from 'qwc2/actions/map';
import viewhistoryReducer from '../reducers/viewhistory';

ReducerIndex.register("viewhistory", viewhistoryReducer);

export const PUSH_VIEW = 'PUSH_VIEW';
export const STEP_VIEW = 'STEP_VIEW';

export function pushView(view) {
    return {
        type: PUSH_VIEW,
        view
    };
}

// Moves one step through the history and shows the resulting view on the map
export function stepView(delta) {
    return (dispatch, getState) => {
        const {entries, index} = getState().viewhistory;
        const target = entries[index + delta];
        if (!target) {
            return;
        }
        dispatch({
            type: STEP_VIEW,
            delta
        });
        dispatch(zoomToPoint(target.center, target.zoom));
    };
}
